export default __webpack_public_path__ + "static/media/css_ico.4726b4ac.svg";